module.exports = {"513437100":"锦城镇","513437101":"西宁镇","513437102":"汶水镇","513437103":"黄琅镇","513437104":"金沙镇","513437105":"永盛镇","513437106":"渡口镇","513437107":"马颈子镇","513437108":"上田坝镇","513437109":"瓦岗镇","513437110":"宝山镇","513437203":"箐口乡","513437214":"柑子乡","513437217":"桂花乡","513437220":"山棱岗乡","513437222":"谷堆乡","513437224":"拉咪乡","513437227":"千万贯乡","513437233":"莫红乡","513437237":"巴姑乡","513437241":"卡哈洛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513437.json
// module id = 2578
// module chunks = 0